// File: UserInfoCard.jsx

import React from 'react';
import styles from './UserProfile.module.css';

const UserInfoCard = ({ user }) => {
  return (
    <div className={styles.avatarContainer}>
      <div className={styles.avatar}>
        {user.avatar ? (
          <img src={user.avatar} alt="User Avatar" style={{ width: '100%', height: '100%' }} />
        ) : (
          <img
            src="https://via.placeholder.com/150"
            alt="Default Avatar"
            style={{ width: '100%', height: '100%' }}
          />
        )}
      </div>
      <button
        className={styles.changeAvatarButton}
        onClick={() => alert('Avatar change functionality coming soon!')}
      >
        Change Avatar
      </button>

      <div className={styles.userDetails}>
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
      </div>
    </div>
  );
};

export default UserInfoCard;
